import { useMemo } from 'react';
import type { NextPendingDTO } from '@shared/api.js';
import { unlockInstantIso, formatHeDate, formatHeTime } from '@shared/time.js';
import { gameTimeZone } from '../../lib/gameTime.js';

/**
 * מסך המתנה למשימה הבאה — לעולם לא חושף תוכן, רק רמז לתזמון אם קיים תנאי זמן (סעיף 47).
 */
export function NoMissionYet({ nextPending }: { nextPending: NextPendingDTO | null }) {
  const zone = gameTimeZone();
  const timeHint = useMemo(() => {
    if (!nextPending?.unlockTimeRaw || !nextPending.date) return null;
    const iso = unlockInstantIso(nextPending.date, nextPending.unlockTimeRaw, zone);
    if (!iso) return null;
    return `${formatHeDate(iso, zone)} בשעה ${formatHeTime(iso, zone)}`;
  }, [nextPending, zone]);

  return (
    <div className="term-text" style={{ padding: 'var(--space-2)' }}>
      <div className="term-line term-line--system">&gt; ממתין להעברה הבאה...</div>
      {!nextPending && (
        <div className="term-line term-line--system">&gt; המבצע טרם החל. יש להמתין להוראת המפעיל.</div>
      )}
      {nextPending && timeHint && (
        <div className="term-line term-line--amber">&gt; ההעברה הבאה צפויה ב-{timeHint}</div>
      )}
      {nextPending && !timeHint && nextPending.hasLocationCondition && (
        <div className="term-line term-line--amber">
          &gt; ההעברה תתקבל אוטומטית עם ההגעה למיקום המיועד
        </div>
      )}
      {nextPending && !timeHint && !nextPending.hasLocationCondition && (
        <div className="term-line term-line--amber">&gt; ממתין לאישור ידני מהמפעיל</div>
      )}
      <div className="term-line">
        <span className="term-cursor" aria-hidden="true" />
      </div>
    </div>
  );
}
